import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { isAuthenticated, isLoading, hasRole } = useAuth();

  if (isLoading) {
    return (
      <div
        className="min-h-screen"
        style={{ background: '#FBFBFC' }}
        aria-busy="true"
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <div
        className="flex items-center justify-center min-h-screen"
        style={{ background: '#FBFBFC' }}
      >
        <div className="text-center max-w-sm">
          <p
            className="font-mono text-[11px] uppercase mb-2"
            style={{ color: '#8C8F98', letterSpacing: '0.04em' }}
          >
            403 · Restricted
          </p>
          <h1
            className="font-display text-3xl mb-2"
            style={{ color: '#262A35' }}
          >
            Access denied.
          </h1>
          <p className="text-sm" style={{ color: '#8C8F98' }}>
            You don't have permission to view this area.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
